// implement your own methods in here, if your data is coming from A rest API

import CurrentSession from './CurrentSession'
import User from './User'
import Laboratory from './Laboratory'
import Product from './Product'
import Distributor from './Distributor'
import Invoice from './Invoice'
import Transit from './Transit'
import Dashboard from './Dashboard'

export default {
  CurrentSession,
  Laboratory,
  User,
  Product,
  Distributor,
  Invoice,
  Transit,
  Dashboard,
}
